import { useState } from "react";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { AssociateInitiativesTriggerPayload } from "../types";

const buildPutUrl = (corporateId: string | number, loId: number) =>
  `/learning-catalogue/${corporateId}/learning-objects/${loId}/initiatives`;

const buildDeleteUrl = (
  corporateId: string | number,
  loId: number,
  initiativeId: number,
) =>
  `/learning-catalogue/${corporateId}/learning-objects/${loId}/initiatives/${initiativeId}`;

export interface AssociateInitiativesSubmitArgs {
  trigger: AssociateInitiativesTriggerPayload;
  currentIds: number[];
  originalIds: number[];
}

export const useAssociateInitiatives = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async ({
    trigger,
    currentIds,
    originalIds,
  }: AssociateInitiativesSubmitArgs) => {
    const originalSet = new Set(originalIds);
    const currentSet = new Set(currentIds);
    const added = currentIds.filter((id) => !originalSet.has(id));
    const removed = originalIds.filter((id) => !currentSet.has(id));

    if (added.length === 0 && removed.length === 0) return;

    setIsSubmitting(true);
    try {
      await Promise.all([
        ...added.map((id) =>
          fetcher<any>(
            buildPutUrl(trigger.corporateId, trigger.objectId),
            MethodType.PUT,
            { id },
          ),
        ),
        ...removed.map((id) =>
          fetcher<any>(
            buildDeleteUrl(trigger.corporateId, trigger.objectId, id),
            MethodType.DELETE,
          ),
        ),
      ]);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submit, isSubmitting };
};
